import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { about_us } from "../../../api/PageApi";


const About = () => {
  const [content, setContent] = useState(""); // HTML content
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchAbout = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await about_us(); 
        if (res?.status && res?.data?.content) {
          setContent(res.data.content); // HTML content
        } else {
          setError("No About Us content available");
        }
      } catch (err) {

        setError("Failed to load About Us content");
      } finally {
        setLoading(false);
      }
    };

    fetchAbout();
  }, []);

  if (loading) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" sx={{ mt: 5, textAlign: "center" }}>
        {error}
      </Typography>
    );
  }

  return (
    <Box sx={{ p: { xs: 2, md: 4 }, maxWidth: 800, mx: "auto" }}>
      <Typography variant="h4" mb={3} fontWeight={600}>
        About Us
      </Typography>

      <Box
        dangerouslySetInnerHTML={{ __html: content }} 
        sx={{
          "& p": { mb: 2 },
          "& h1, & h2, & h3": { mt: 2, mb: 1 },
          "& a": { color: "#1976d2", textDecoration: "underline" },
        }}
      />
    </Box>
  );
};

export default About;
